import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngxs/store';
import { GuidedTourStatus } from 'app/guided-tour/models/guided-tour-state.model';
import * as GuidedTourActions from 'app/guided-tour/state/guided-tour.actions';

@Component({
  selector: 'app-start-tour-dialog',
  templateUrl: './start-tour-dialog.component.html',
  styleUrls: ['./start-tour-dialog.component.scss']
})
export class StartTourDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<StartTourDialogComponent>,
    public store: Store
  ) { }

  ngOnInit() {
    this.dialogRef.updatePosition({ bottom: `30px`, right: `30px`});
  }

  startTour() {
    setTimeout(() => this.store.dispatch(new GuidedTourActions.SetGuidedTourToggleStatus(GuidedTourStatus.ON)), 500);
  }

}
